// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroReviews_wrapper__57KSb","review":"HeroReviews_review__cmdE3","desktop":"HeroReviews_desktop__dW2PU","mobile":"HeroReviews_mobile__uGDo7"};